import {makeStyles} from "@material-ui/core/styles";
import { fade } from "@material-ui/core/styles/colorManipulator";

const theme = (props) => {
  const styles = makeStyles(theme => ({
    root: {
      height: '100vh',
      width: '100vw',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& .container': {
        width: '100%',
        '& .logo': {
          height: 175,
          maxWidth: 400,
          margin: '0 auto',
          backgroundSize: '100%',
          background: `transparent url("${props.logoAuthPath}") no-repeat scroll center center`,
        },
        '& .body': {}
      },

    },
    paperContainer: {
      padding: 45,
      margin: '0px 10px',
      textAlign: 'center',
      borderRadius: 16,

      '& img': {
        width: 200,
      },

      '& h1': {
        fontSize: 22,
        marginTop: 30
      },

      '& p': {
        fontSize: 16,
        lineHeight: "1.6",
        marginBottom: 28,
        color: "#4B5563"
      },
    },

    btn: {
      backgroundColor: "#1F28A6",
      color: 'white',
      borderRadius: 28,
      padding: "9px 18px",
      textDecoration: "none",
      fontSize: 14,
      textTransform: 'none',
      fontWeight: "400 !important",

      '&:hover': {
        backgroundColor: "rgb(31, 40, 166, 0.7)"
      },
    }
  }));
  return styles();
}
export default theme;

